import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/Login/LoginWx.vue')
    },
    {
      path: '/HomePage',
      name: 'HomePage',
      redirect: '/HomePage/Main',
      component: () => import('@/views/HomePage.vue'),
      children: [
        {
          path: '/HomePage/Main',
          name: 'Main',
          component: () => import('@/views/Main/Main.vue'),
          meta: {
            name: '首页',
            isMenu: true
          }
        },
        {
          path: '/HomePage/TrainingCourse',
          name: 'TrainingCourse',
          component: () => import('@/views/TrainingCourse/TrainingCourse.vue'),
          meta: {
            name: '课程培训',
            isMenu: true
          }
        },
        // {
        //   path: '/HomePage/PracticeTests',
        //   name: 'PracticeTests',
        //   component: () => import('@/views/PracticeTests/PracticeTests.vue'),
        //   meta: {
        //     name: '试题练习',
        //     isMenu: true
        //   }
        // },
        {
          path: '/HomePage/H5Culture',
          name: 'H5Culture',
          component: () => import('@/views/H5Culture/H5Culture.vue')
        },
        {
          path: '/HomePage/EnterpriseCulture',
          name: 'EnterpriseCulture',
          component: () => import('@/views/EnterpriseCulture/index.vue'),
          meta: {
            name: '企业文化',
            isMenu: true
          },
          children: [
            {
              path: '/HomePage/EnterpriseCulture/BigEvent',
              name: 'BigEvent',
              component: () => import('@/views/EnterpriseCulture/BigEvent.vue'),
              meta: {
                name: '企业大事件',
                isMenu: true
              }
            },
            {
              path: '/HomePage/EnterpriseCulture/BigEventDetails',
              name: 'BigEventDetails',
              component: () => import('@/views/EnterpriseCulture/BigEventDetails.vue'),
              meta: {
                name: '企业大事件-详情'
              }
            },
            {
              path: '/HomePage/EnterpriseCulture/StaffPresence',
              name: 'StaffPresence',
              component: () => import('@/views/EnterpriseCulture/StaffPresence.vue'),
              meta: {
                name: '员工风采',
                isMenu: true
              }
            },
            {
              path: '/HomePage/EnterpriseCulture/EnterpriseCulture',
              name: 'SubEnterpriseCulture',
              component: () => import('@/views/EnterpriseCulture/EnterpriseCulture.vue'),
              meta: {
                name: '企业文化',
                isMenu: true
              }
            }
          ]
        },
        {
          path: '/Share',
          name: 'Share',
          component: () => import('@/views/Share/Share.vue'),
          meta: {
            name: '共享交流',
            isMenu: true
          }
        },
        {
          path: '/HomePage/HotspotList',
          name: 'HotspotList',
          component: () => import('@/views/FdHotspot/HotspotList.vue'),
          meta: {
            name: '分蛋看点',
            isMenu: true
          }
        }
        // {
        //   path: '/HomePage/H5Culture',
        //   name: '/H5Culture',
        //   component: () => import('@/views//H5Culture//H5Culture.vue'),
        //   meta: {
        //     name: '分蛋看点',
        //     isMenu: true
        //   }
        // }
      ]
    },
    {
      path: '/PersonalCenter',
      name: 'PersonalCenter',
      component: () => import('@/views/PersonalCenter/PersonalCenter.vue')
    },
    {
      path: '/TestPaper',
      name: 'TestPaper',
      component: () => import('@/views/PersonalCenter/TestPaperSingle.vue')
    },
    {
      path: '/TestQuestions',
      name: 'TestQuestions',
      component: () => import('@/views/PersonalCenter/TestQuestions.vue')
    },
    {
      path: '/ExamDetail',
      name: 'ExamDetail',
      component: () => import('@/views/PersonalCenter/ExamDetail.vue')
    }
  ]
})
